<template>
	<div>
		<FormGroup label="Kontaktperson" alias="contact" label-cols-md="3" v-slot:default="props" scope="related-contact">
			<OptifySelect :options="contacts" v-model="form.contactId" :multiple="false" :show-labels="false"
				@search="search" @select="select" label="text" track-by="id" :internal-search="false" autocomplete="off">
			</OptifySelect>

			<input type="hidden" v-validate="'required'" v-model="form.contactId" data-vv-as="Kontakt"
				:class="{ 'is-invalid': !props.state }" name="contact" data-vv-scope="related-contact" />
		</FormGroup>
	</div>
</template>

<script>

export default {
	data: () => ({
		form: {
			contactId: null,
			organizationId: null,
		},
		contacts: []
	}),
	inject: ['$validator'],
	components: {},
	computed: {},
	watch: {},
	props: ["entity"],
	methods: {
		search(query) {			
			this.$http.post("/api/multi-select/contacts", {
				search: query,
				value: this.form.contactId,
				values: [],
				taggable: true
			}).then(x => {
				this.contacts = x.data;
			});
		},
		select(item) {
			if (item.isNew === true) {
				this.$http.post("/api/multi-select/contacts/create", {
					name: item.text
				}).then(x => {
					this.form.contactId = x.data.id;
					this.search();
				});
			}
		},
		ok() {
			this.$validator.validate("related-contact.*").then(valid => {
				if (valid) {
					this.$http.post("/api/module/contacts/related-contact", this.form).then(x => {
						this.$emit("close");
					});
				}
			});
		},
		cancel() {
			this.$emit("close");
		}
	},
	created() {
		this.search();

		this.form.organizationId = this.entity.Id;
	},
	mounted() {},
};
</script>